<template>
  <div class="mx-auto contentsWidth mt-4">
    <div class="">
      <p class="title mb-0">{{base.year}}年度 {{base.name}} - 申請</p>
      <hr class="title">
    </div>

      <div
        class="my-2 text-center">
        <p class="mb-1 notice-text" v-if="isOutTerm">申請期間外のため、申請はできません。申請期間は{{outTermText.from}}から{{outTermText.to}}までです。</p>
      </div>

    <div class="notice mx-auto contentsWidth my-4 py-3 px-4">
      <p class="mb-1 warning">・すべての必要項目に入力後、登録を行ってください。</p>
      <p class="mb-1 warning">・数字は半角で入力してください。</p>
      <p class="mb-1">・添付ファイルについては、一時保存又は申請後に閲覧できます。</p>
      <div v-if="Object.keys(assets).length > 0">
        <p class="mb-1">・添付ファイルの原本は以下からダウンロードしてください。</p>
        <p class="mb-1">・「{{fileLang}}1」「{{fileLang}}2」は申請者が作成。「{{fileLang}}1」をもとにシステムに入力してください。なお、「{{fileLang}}1」は財団への提出は不要です</p>
      </div>
      <p
        v-for="(asset, index) in assets" :key="`openFile_${index}`"
        class="mb-0 ml-5"><b-link
              @click="downloadOpenFile(asset.id, asset.name)">
                {{asset.name}}
              </b-link></p>
    </div>

    <div
      class="mb-3 mx-auto contentsWidth">

      <div v-if="base.status">
        <v-app-controlview
          :code="base.code"
          :status="base.status"
          :reason="base.reason"
          :comments="comments"
          :isShowComments="true"/>
      </div>
      <div
        v-for="(page, index) in pages" :key="index">
        <v-app-form
          :writable="onTime && writeble"
          :pageIndex="index"
          :assets="assets"
          :downloadOpenFile="downloadOpenFile"
          :downloadFormFile="downloadFormFile"
          :downloadApploadedFile="downloadApploadedFile"/>
      </div>
    </div>

    <div class="contentsWidth mt-4 mb-3 flex flexCenter flexColumn">
      <p
        v-show="hasEmpty"
        class="warning">
        未入力の必須項目があります。すべての必須項目に入力後、申請を行ってください。
      </p>
      <p class="mb-1">添付ファイルについては、一時保存または申請後に閲覧できます。</p>
    </div>

    <div class="contentsWidth mt-3 mb-3 flex flexCenter">
      <!-- <b-button
        v-show="hasPrevApp"
        @click="prevApp"
        class="btn btn-primary btn-lg mr-4 bold">
        前の申請
      </b-button> -->
      <b-button
        class="btn btn-lg mr-4 bold"
        to="/university/applications/list">
        一覧に戻る
      </b-button>
        <!-- 申請期間内かつ未提出・一時保存の場合のみ表示 -->
        <b-button
          v-if="onTime && isUnsubmited"
          @click="tempSave"
          variant="primary"
          class="btn btn-lg mr-4 bold"
          >一時保存</b-button>
      <b-button
        v-if="onTime && writeble"
        @click="save"
        variant="info"
        class="btn btn-primary btn-lg mr-4 bold">
        申請
      </b-button>
      <!-- <b-button
        v-show="hasNextApp"
        @click="nextApp"
        class="btn btn-primary btn-lg mr-4 bold">
        次の申請
      </b-button> -->
        <b-button
          v-if="isSubmited && onTime"
          @click="withdraw"
          variant="dark"
          class="btn btn-primary btn-lg bold"
          >申請の削除</b-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import api from '@/modules/api';
import download from '@/modules/download';
import AppForm from '@/components/gas/parts/Form.vue';
import CONST_STATUS from '@/constants/appStatus';
import AppControlview from '@/components/gas/parts/Controlview.vue';

export default {
  name: 'uniApplicationEdit',
  components: {
    'v-app-form': AppForm,
    'v-app-controlview': AppControlview,
  },
  data() {
    return {
      base: {},
      applicationId: null,
      status: null,
      hasUserErr: false,
      hasPageErr: [],
      assets: {},
      onTime: null,
      comments: {},
    };
  },
  computed: {
    pages() {
      return this.$store.state.gasApplicationForm.pages;
    },
    filterdIdList() {
      return this.$store.state.cmsApplicationSearch.filterdIdList;
    },
    filterdIdListIndex() {
      return this.filterdIdList.indexOf(Number(this.applicationId));
    },
    hasNextApp() {
      if (this.filterdIdList.length === 0) {
        return false;
      }
      const newIndex = this.filterdIdListIndex + 1;
      return newIndex < this.filterdIdList.length;
    },
    hasPrevApp() {
      if (this.filterdIdList.length === 0) {
        return false;
      }
      const newIndex = this.filterdIdListIndex - 1;
      return newIndex >= 0;
    },
    hasEmpty() {
      // 入力フォーム
      const { inputs } = this.$store.state.gasApplicationInput;
      const formOptionData = this.$store.state.gasApplicationForm.optionDataList;
      const findFormResult = inputs.find((input) => {
        if (formOptionData[input.option_id] && !formOptionData[input.option_id].is_required) {
          return false;
        }
        const noSelect = input.field_answer_id === null;
        const notext = input.field_answer_text === '';
        const noFile = input.uploadedFileKey === '';
        return noSelect && notext && noFile;
      });
      return typeof findFormResult !== 'undefined';
    },
    onGoing() {
      if (this.base.result_announcement_datetime === null) {
        return true;
      }
      const now = moment();
      const end = moment(this.base.result_announcement_datetime);
      return now.isBefore(end);
    },
    isSubmited() {
      return this.status === CONST_STATUS.APP_STATUS.SUBMIT;
    },
    isUnsubmited() {
      return !this.status || this.status === CONST_STATUS.APP_STATUS.TEMPSAVE;
    },
    writeble() {
      // 期間内は、未提出と差戻し、一時保存がOK
      if (this.onTime) {
        return !this.status || this.status === CONST_STATUS.APP_STATUS.RETURN || this.status === CONST_STATUS.APP_STATUS.TEMPSAVE;
      }
      // 期間外は、差戻しのみOK
      return this.status === CONST_STATUS.APP_STATUS.RETURN;
    },
    isOutTerm() {
      if (!this.base) {
        return false;
      }
      return !moment().isBetween(this.base.open_datetime, this.base.close_datetime);
    },
    isPublic() {
      if (!this.base) {
        return false;
      }
      return moment().isAfter(this.base.application_announcement_datetime);
    },
    outTermText() {
      if (!this.isOutTerm || !this.base) {
        return {};
      }
      return {
        from: moment(this.base.open_datetime).format('YYYY/MM/DD HH:mm'),
        to: moment(this.base.close_datetime).format('YYYY/MM/DD HH:mm'),
      };
    },
    fileLang() {
      return this.base.name === '外国人留学生助成' ? 'Application Form' : '申請書';
    },
    upFileKeys() {
      return this.$store.state.gasApplicationInput.upFileKeys;
    },
    tempUpFileList() {
      return this.$store.state.gasApplicationInput.tempUpFileList;
    },
  },
  methods: {
    async fetchApptype(appId, seriesId, year) {
      const param = {
        appId, seriesId, year,
      };
      const response = await api.send('/api/uni/applications/edit', param)
        .catch((err) => {
          console.error(err);
        });

      if (!response) {
        await this.alert('申請のデータを取得できませんでした。');
        this.$router.push({ path: '/university/applications/list' });
        return;
      }
      const {
        base,
        pages,
        answers,
        assets,
        comments,
      } = response.data;
      this.base = base;
      if (!this.isPublic) {
        this.$router.push('/university/applications/list');
      }
      this.status = base.status;
      this.assets = assets;
      this.onTime = response.data.onTime;
      this.comments = comments;
      this.$store.commit('gasApplicationForm/setDbData', pages);
      this.$store.commit('gasApplicationForm/setApplicationTypeId', base.application_type_id);
      this.$store.commit('gasApplicationForm/setYear', base.year);
      this.$store.commit('gasApplicationInput/setDbData', { pages, answers });
    },
    async save() {
      const msg = '上記の内容で申請を登録します。\n申請してもよろしいですか？';
      if (!await this.confirm(msg)) {
        return;
      }
      this.$store.dispatch('page/onWaiting');
      const storeData = {
        appId: this.base.id,
        apptypeId: this.base.application_type_id,
        inputs: JSON.stringify(this.$store.state.gasApplicationInput.inputs),
      };
      const { files } = this.$store.state.gasApplicationInput;
      Object.keys(files).forEach((key) => {
        storeData[key] = files[key];
      });
      const response = await api.sendForm('/api/uni/applications/save', storeData)
        .catch(async (err) => {
          if (err.response.status === 422) {
            await this.alert('入力内容に誤りがありました。修正してください。', false);
            this.$store.commit('gasApplicationInput/setErrMessages', err.response.data.formErrs);
          } else {
            await this.alert(err.response.data.msg, false);
          }
          return false;
        });
      if (!response) {
        this.$store.dispatch('page/offWaiting');
        return;
      }
      await this.alert('申請が完了しました', false);
      this.$store.commit('gasApplicationForm/init');
      this.hasPageErr = []; // タブのエラーマーク初期化
      const { appId, seriesId, year } = this.$route.params;
      this.applicationId = appId;
      if (!appId) {
        this.$store.dispatch('page/offWaiting');
        this.$router.push({ path: '/university/applications/list' });
        return;
      }
      await this.fetchApptype(appId, seriesId, year);
      this.$store.dispatch('page/offWaiting');
    },
    async tempSave() {
      if (!await this.confirm('現在の内容で一時保存をしてもよろしいですか？')) {
        return;
      }
      this.$store.dispatch('page/onWaiting');
      // eslint-disable-next-line
      const storeData = {
        appId: this.base.id,
        apptypeId: this.base.application_type_id,
        inputs: JSON.stringify(this.$store.state.gasApplicationInput.inputs),
      };
      const { files } = this.$store.state.gasApplicationInput;
      Object.keys(files).forEach((key) => {
        storeData[key] = files[key];
      });
      const response = await api.sendForm('/api/uni/applications/tempSave', storeData)
        .catch(async (err) => {
          if (err.response.status === 422) {
            await this.alert('入力内容に誤りがありました。修正してください。', false);
            this.$store.commit('gasApplicationInput/setErrMessages', err.response.data.formErrs);
          } else {
            await this.alert(err.response.data.msg, false);
          }
          return false;
        });
      if (!response) {
        this.$store.dispatch('page/offWaiting');
        return;
      }
      await this.alert('一時保存が完了しました', false);
      this.$store.commit('gasApplicationForm/init');
      this.hasPageErr = []; // タブのエラーマーク初期化
      const { appId, seriesId, year } = this.$route.params;
      this.applicationId = appId;
      // 新規申請の場合、editにパスを変更する
      if (this.$route.name === 'universityApplicationCreate') {
        this.applicationId = response.data.appId;
        this.$store.dispatch('page/offWaiting');
        this.$router.push({ path: `/university/applications/edit/${this.applicationId}` });
      }
      await this.fetchApptype(this.applicationId, seriesId, year);
      this.$store.dispatch('page/offWaiting');
    },
    async withdraw() {
      if (!await this.confirm('入力内容はすべて破棄されます。この申請を削除してもよろしいですか？')) {
        return;
      }
      this.$store.dispatch('page/onWaiting');
      const param = {
        appId: this.base.id,
      };
      const response = await api.send('/api/uni/applications/withdraw', param)
        .catch(async () => {
          await this.alert('申請の削除に失敗しました。', false);
          return false;
        });
      this.$store.dispatch('page/offWaiting');
      if (!response) {
        return;
      }
      await this.alert('申請を削除しました。');
      this.$router.push({ path: '/university/applications/list' });
    },
    async downloadOpenFile(assetId, assetName) {
      const param = {
        assetId,
        assetName,
      };
      this.$store.dispatch('page/onWaiting');
      const requireBlob = true;
      const response = await api.send('/api/uni/applications/download/openFile', param, requireBlob)
        .catch((err) => {
          console.error(err);
        });
      this.$store.dispatch('page/offWaiting');
      if (!response) {
        await this.alert('ファイルのダウンロードに失敗しました。');
        return;
      }
      download.blob(response.data, assetName);
    },
    async downloadFormFile(fieldId, optionId, fileName) {
      const param = {
        application_id: this.base.id,
        field_id: fieldId,
        option_id: optionId,
        answer_no: 1, // ファイルは当面１つ固定
      };
      param.user_id = this.$store.state.gasApplicationForm.user_id;
      const url = '/api/uni/applications/download/uploadedFile';

      this.$store.dispatch('page/onWaiting');
      const response = await api.send(url, param, true)
        .catch((err) => {
          console.error(err);
        });
      this.$store.dispatch('page/offWaiting');
      if (!response) {
        await this.alert('ファイルのダウンロードに失敗しました。');
        return;
      }
      download.blob(response.data, fileName);
    },
    // async nextApp() {
    //   const newIndex = this.filterdIdListIndex + 1;
    //   this.$router.push({ path: `/cms/applications/edit/${this.filterdIdList[newIndex]}` });
    //   this.$store.dispatch('page/onLoading');
    //   this.applicationId = this.filterdIdList[newIndex];
    //   await this.fetchApptype(this.filterdIdList[newIndex]);
    //   this.$store.dispatch('page/offLoading');
    // },
    // async prevApp() {
    //   const newIndex = this.filterdIdListIndex - 1;
    //   this.$router.push({ path: `/cms/applications/edit/${this.filterdIdList[newIndex]}` });
    //   this.$store.dispatch('page/onLoading');
    //   this.applicationId = this.filterdIdList[newIndex];
    //   await this.fetchApptype(this.filterdIdList[newIndex]);
    //   this.$store.dispatch('page/offLoading');
    // },
    setErrors(userErrs) {
      // ユーザー
      this.hasUserErr = Object.keys(userErrs).length > 0;
      // フォーム
      const { inputs } = this.$store.state.gasApplicationInput;
      Object.keys(this.pages).forEach((index) => {
        const { fields } = this.pages[index];
        const thisPageFieldIdList = Object.keys(fields).map((fieldKey) => {
          return fields[fieldKey].field_id;
        });
        let findFormErr = inputs.find((input) => {
          const searchedIndex = thisPageFieldIdList.indexOf(input.field_id);
          const hasErr = input.errMessages.length > 0;
          return searchedIndex !== -1 && hasErr;
        });
        // 例外的にページにエラーマークをつけたいとき
        if (this.pageErrs.includes(Number(index))) {
          findFormErr = true;
        }
        this.hasPageErr.splice(index, 1, findFormErr);
      });
    },
    async downloadApploadedFile(uploadedFileKey, index, fileName) {
      const fileKey = this.upFileKeys[uploadedFileKey][index];
      const url = '/api/uni/confupfile/fileDownload';
      this.$store.dispatch('page/onWaiting');
      if (!this.tempUpFileList[uploadedFileKey] || !this.tempUpFileList[uploadedFileKey][fileKey]) {
        const itemNumber = `${uploadedFileKey}-${fileKey}`;
        const tempUpUrl = '/api/uni/confupfile';
        const tempParam = {
          itemNumber: JSON.stringify(itemNumber),
        };
        const { files } = this.$store.state.gasApplicationInput;
        tempParam.file = files[uploadedFileKey];
        const tempResponse = await api.sendForm(tempUpUrl, tempParam, true)
          .catch((err) => {
            console.error(err);
          });
        if (!tempResponse) {
          this.$store.dispatch('page/offWaiting');
          await this.alert('ファイルのダウンロードに失敗しました。再度アップロードしてお試しください。');
          return;
        }
        const saveTempResponse = {
          target: uploadedFileKey,
          subKey: fileKey,
          path: tempResponse.data.path,
        };
        this.$store.commit('gasApplicationInput/saveTempPath', saveTempResponse);
      }
      const path = this.tempUpFileList[uploadedFileKey][fileKey];
      const param = {
        fileName: path,
      };
      const response = await api.send(url, param, true)
        .catch((err) => {
          console.error(err);
        });
      this.$store.dispatch('page/offWaiting');
      if (!response) {
        await this.alert('ファイルのダウンロードに失敗しました。');
        return;
      }
      download.blob(response.data, fileName);
    },
  },
  // ロード画面
  async created() {
    this.$store.dispatch('page/onLoading');
    this.$store.commit('gasApplicationForm/init');
    const { appId, seriesId, year } = this.$route.params;
    this.applicationId = appId;
    await this.fetchApptype(appId, seriesId, year);
    this.$store.dispatch('page/offLoading');
  },
};
</script>

<style scoped>
  .errorMark {
    position: absolute;
    top: -7px;
    left: 150px;
  }
  .warning {
    color: #dc3545;
  }
  .subject {
    border-bottom: .1rem solid #A0A9D0;
    margin: 3rem auto 0;
    width: 1080px;
  }

  .err-wrap>p{
    color: #dc3545;
  }

  .notice {
    background-color: #DDD;
  }

  .err-wrap>p, .notice-text{
    color: #dc3545;
  }
</style>
